module.exports = __webpack_public_path__ + "static/media/de_cbble.bdfeab81.jpg";